import React from "react";

const Header = () => {
  return (
    <header className="timeline-header">
      <div className="logo-container">
        <img
          src="./images/Frame 250917 (3).png"
          alt="River Rats Logo"
          className="logo-image"
          style={{ width: "100px", height: "auto" }}
        />
      </div>
      <div>
        <div style={{ marginBottom: "1.5rem" }}>
          <span
            style={{
              display: "inline-block",
              background: "#F0A567",
              color: "white",
              fontSize: "0.875rem",
              fontWeight: "600",
              padding: "0.25rem 1rem",
              borderRadius: "9999px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              marginBottom: "1rem",
            }}
            className="marketing-case-study-label"
          >
            Marketing Case Study
          </span>
        </div>

        <h1 className="timeline-title">
          Marketing River Rats{" "}
          <span style={{ display: "block", color: "#FFE0C0" }}>
            Kickstarter Campaign
          </span>
        </h1>
        <p
          style={{
            fontSize: "1.1rem",
            marginTop: "0.5rem",
            color: "#FFE0C0",
            fontStyle: "italic",
          }}
        >
          by Robin Stokkel
        </p>

        <div className="timeline-description">
          <p
            style={{
              fontSize: "1.25rem",
              marginBottom: "1.5rem",
              color: "#FFE0C0",
            }}
          >
            A detailed journey of what worked and what didn't in marketing a
            card game
          </p>

          <p
            style={{
              color: "#FFF5E8",
              marginBottom: "2rem",
              lineHeight: "1.6",
            }}
          >
            This timeline outlines the marketing journey for River Rats, a
            cooperative card game. From initial engagement to Kickstarter
            launch, follow the strategies, successes, and lessons learned
            throughout the campaign.
          </p>

          <div
            style={{ display: "flex", justifyContent: "center", gap: "1rem" }}
          >
            <a
              href="https://robinstokkel.com"
              style={{
                background: "white",
                color: "#000000",
                fontWeight: "500",
                padding: "0.75rem 1.5rem",
                borderRadius: "0.5rem",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                textDecoration: "none",
              }}
        /*      onClick={(e) => {
                e.preventDefault();
                document
                  .querySelector("main")
                  .scrollIntoView({ behavior: "smooth" });
              }} */
            > 
              Back to Robin's Blog
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
